"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _ThemeHelper.createStyles)(function (theme) {
  var _theme$scrollbars;

  return {
    menu: {
      list: {
        padding: theme.spacing(1, 0)
      }
    },
    button: {},
    item: {
      padding: theme.spacing(1, 2),
      "&:active": {
        backgroundColor: theme.palette.action.selected
      }
    },
    paper: _objectSpread(_objectSpread({
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[5]
    }, (_theme$scrollbars = theme.scrollbars) === null || _theme$scrollbars === void 0 ? void 0 : _theme$scrollbars.main), {}, {
      overflowX: "hidden"
    }),
    icon: {
      fontSize: theme.typography.fontSize,
      color: theme.palette.text.secondary,
      minWidth: 36,
      "& svg": {
        fontSize: theme.typography.fontSize
      }
    }
  };
});
exports.styles = styles;